import { render } from "./Chat.vue?vue&type=template&id=15591cfe&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=15591cfe&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-15591cfe"

export default script